<!-- Contact -->
<section id="contact">


    <!-- Contact Map -->
    <div class="box-grey">

        <div class="google-map-big">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18011.448909580347!2d79.10239018024245!3d21.1367994783565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c0b51113df3f%3A0x186bd56dfacb450b!2sNagpur%20Mahanagarpalika%20Karmachari%20Sahakari%20Bank%20Limited!5e0!3m2!1sen!2sin!4v1629283655458!5m2!1sen!2sin"
                width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe></div>
    </div>
    <!-- Contact Map End -->

    <!-- Contact Info -->
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="row">
                <!-- Contact Information -->
                <div class="col-md-6 col-sm-12">
                    <ul class="address-list">
                        <li><i class="fa fa-map-marker"></i>कोठी रोड, महाल, नागपूर, महाराष्ट्र - 440032.</li>
                        <li><i class="fa fa-phone"></i>(0712) - 2721225, 2721832</li>
                        <!-- <li><i class="fa fa-mobile-phone"></i>+20 7435 0228</li> -->
                        <li><i class="fa fa-send"></i><a href="mailto:info@nmpksbank.in">info@nmpksbank.in</a></li>
                    </ul>
                    <hr>
                    <h3 class="line-bottom left">Follow us</h3>
                    <p>आम्हाला फ्ललोव करण्यासाठी खालील लिंक वर क्लिक करा. </p>
                    <ul class="social-icons social-grey nav-default clearfix">
                        <li *ngFor="let item of allSocialData">
                            <a href="https://{{item.socialLink}}" target="_blank" class="{{item.socialLinkCss}}">
                                <i class="{{item.socialLinkIconCss}}"></i>
                            </a>
                        </li>
                        <!-- <li><a href="#" class="facebook"><i class="fa fa-facebook"></i></a></li>
                        <li><a href="#" class="twitter"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#" class="google"><i class="fa fa-google-plus"></i></a></li>
                        <li><a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a></li> -->
                    </ul>
                </div>
                <!-- Contact Information End -->

                <!-- Contact Form -->
                <div class="col-md-6 col-sm-12">
                    <app-alert></app-alert>
                    <div class="data-form">
                        <form [formGroup]="contactForm" (ngSubmit)="contact()">
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <label>Name</label>
                                    <div class="form-field">
                                        <i class="fa fa-user"></i>
                                        <input type="text" formControlName="nmpk_feedBackName" name="name" placeholder="Enter your name" required>
                                        <small class="text-danger" *ngIf="!contactForm.get('nmpk_feedBackName').valid && contactForm.get('nmpk_feedBackName').touched">
                                      <span *ngIf="contactForm.get('nmpk_feedBackName').errors['required']">Please enter full name.</span>
                                      <span *ngIf="contactForm.get('nmpk_feedBackName').errors['minlength']">Please enter at list 3 characters.</span>
                                    </small>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <label>E-Mail</label>
                                    <div class="form-field">
                                        <i class="fa fa-envelope-o"></i>
                                        <input type="email" formControlName="nmpk_feedBackEmail" name="name" placeholder="Enter your email" required>
                                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                                        <small class="text-danger" *ngIf="!contactForm.get('nmpk_feedBackEmail').valid && contactForm.get('nmpk_feedBackEmail').touched"><i class="fa fa-envelope"></i> Please enter valid email.</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <label>Mobile No.</label>
                                    <div class="form-field">
                                        <i class="fa fa-phone"></i>
                                        <input type="tel" name="name" formControlName="nmpk_feedBackMobile" placeholder="Enter your mobile" required>
                                        <small class="text-danger" *ngIf="!contactForm.get('nmpk_feedBackMobile').valid && contactForm.get('nmpk_feedBackMobile').touched">
                                      <span *ngIf="contactForm.get('nmpk_feedBackMobile').errors['required']"><i class="fa fa-phone"></i> Please enter mobile no.</span>
                                      <span *ngIf="contactForm.get('nmpk_feedBackMobile').errors['maxlength']"><i class="fa fa-phone"></i> Please enter 10 digit mobile no.</span>
                                      <span *ngIf="contactForm.get('nmpk_feedBackMobile').errors['minlength']"><i class="fa fa-phone"></i> Please enter 10 digit mobile no.</span>
                                      <span *ngIf="contactForm.get('nmpk_feedBackMobile').errors['pattern']"><i class="fa fa-phone"></i> Please enter numerically value.</span>
                                    </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                    <label>Message</label>
                                    <div class="form-field">
                                        <i class="fa fa-pencil-square-o"></i>
                                        <textarea name="name" formControlName="nmpk_feedBack" placeholder="Enter your message" required></textarea>
                                        <small class="text-danger" *ngIf="!contactForm.get('nmpk_feedBack').valid && contactForm.get('nmpk_feedBack').touched">
                                      <span *ngIf="contactForm.get('nmpk_feedBack').errors['required']"><i class="fa fa-phone"></i> Please enter feedback.</span>
                                      <span *ngIf="contactForm.get('nmpk_feedBack').errors['minlength']">Please enter at list 50 characters.</span>
                                    </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                    <input type="submit" class="btn btn-default" value="SEND YOUR MESSAGE">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- Contact Form End -->
            </div>
        </div>
    </div>
    <!-- Contact Info End -->
</section>
<!-- Contact End -->